import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { I18nModule, UrlModule } from '@spartacus/core'
import { IconModule, SpinnerModule } from '@spartacus/storefront'
import { EbPartnersModule } from './contact-card/eb-partners.module'
import { EbContactFormModule } from './contact-form/eb-contact-form.module'
import { EbRfpFormModule } from './rfp-form/eb-rfp-form.module'

@NgModule({
  imports: [
    CommonModule,
    I18nModule,
    UrlModule,
    IconModule,
    SpinnerModule,
    EbRfpFormModule,
    EbContactFormModule,
    EbPartnersModule
  ]
})
export class EbSupportModule {}
